// Define the class names to be animated
const classNames = '.to-top';

// Function to handle intersection events
function handleIntersect(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('appear');
      observer.unobserve(entry.target); // Stop observing the element once it has appeared
    }
  });
}

// Create an IntersectionObserver instance
const observer = new IntersectionObserver(handleIntersect, {
  root: null, // Use the viewport as the container
  rootMargin: '0px 0px 100px 0px', // Trigger 100px before the element enters the viewport
  threshold: 0 // Trigger when any part of the element is visible
});

// Select all elements to be animated
const animateElements = document.querySelectorAll(classNames);

// Start observing each element
animateElements.forEach(element => {
  observer.observe(element);
});



